import { Transmitter } from "./transmit/transmitter";
import { PubSub } from "./pubSub/pubSub";
import { Queries } from "./query/queries";
export class Router {
    constructor(gluePromise, asyncConstructors, loggerClient) {
        this.asyncConstructors = asyncConstructors;
        this.loggerClient = loggerClient;
        this.transmitter = new Transmitter(gluePromise, this.asyncConstructors, loggerClient);
        this.pubSub = new PubSub(gluePromise, this.asyncConstructors, loggerClient);
        this.queries = new Queries(gluePromise, this.asyncConstructors, loggerClient);
    }
    async onReady(cb) {
        await this.asyncConstructors.ready();
        cb?.();
    }
    async onFailure(cb) {
        return;
    }
    addListener(channel, eventHandler) {
        return this.transmitter.addListener(channel, eventHandler);
    }
    removeListener(channel, eventHandler) {
        return this.transmitter.removeListener(channel, eventHandler);
    }
    transmit(toChannel, data, options) {
        return this.transmitter.transmit(toChannel, data, options);
    }
    addResponder(channel, queryEventHandler) {
        this.queries.addResponder(channel, queryEventHandler);
    }
    removeResponder(responderChannel) {
        this.queries.removeResponder(responderChannel);
    }
    query(responderChannel, queryEvent, queryParams, responseEventHandler) {
        return this.queries.query(responderChannel, queryEvent, queryParams, responseEventHandler);
    }
    subscribe(topic, notifyCallback) {
        return this.pubSub.subscribe(topic, notifyCallback);
    }
    publish(topic, event) {
        return this.pubSub.publish(topic, event);
    }
    addPubSubResponder(topic, initialState, params, callback) {
        return this.pubSub.addPubSubResponder(topic, initialState, params, callback);
    }
    removePubSubResponder(topic) {
        return this.pubSub.removePubSubResponder(topic);
    }
    unsubscribe(subscribeIDStruct) {
        this.pubSub.unsubscribe(subscribeIDStruct);
    }
    trustedMessage(incomingMessage) {
        return this.pubSub.trustedMessage(incomingMessage);
    }
    disconnectAll() {
        this.pubSub?.disconnectAll();
    }
}
